import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const AgriPromoter = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const { sendRequest: getAgriPromoterData } = useHttp();

  const fillAgriPromoterData = (
    employeeId,
    // stateName,
    // farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/agriPromoterReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getAgriPromoterData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillAgriPromoterData(0, 0, "");
  }, [getAgriPromoterData]);

  const fieldsToExport = [
    "employeeCode",
    "employeeName",
    "agriPromoterCode",
    "state",
    "lga",
    "villageName",
    "cropName",
    "varietyName",
    "noOfDemoEstablished",
    "noOfDemoTarget",
    "plantHeightInCm",
    "stemGirthInCm",
    "plantGrowthStageUniformity",
    "demoSizeInSqm",
    "yieldInKg",
    "yieldMetricsTonnesHa",
    "farmersYieldKg",
    "farmersYieldMetricsTonnesHa",
    "latitude",
    "longitude",
  ];
  
  const customHeaders = [
    "Agri Promoter Date",
    "Promoter Id",
    "Agri Promoter Name",
    "Agri Promoter Code",
    "State",
    "LGA",
    "Village Name",
    "Crop Name",
    "Variety Name",
    "Plant Height (cm)",
    "Stem girth (cm)",
    "Plant Growth Stage/Uniformity",
    "Demo Size (Square Meter)",
    "Yield (kg)",
    "Yield (Metrics tonnes/Ha)",
    "Farmer's Yield (Kg)",
    "Farmer's Yield (Metrics tonnes/Ha)",
    "Latitude",
    "Longitude",
  ];
  
  const handleExportExcel = async () => {
    const filename = "AgriPromoter.xlsx";
  
    const processedData = data.map((item) => {
      const coordinates = item.plotCoordinates
      ? typeof item.plotCoordinates === "string"
        ? JSON.parse(item.plotCoordinates)
        : item.plotCoordinates
      : []; // Or some other default value like null or undefined
    
    let latitudes = "";
    let longitudes = "";
    
    if (coordinates && Array.isArray(coordinates)) {
      latitudes = coordinates.map((coord) => coord.latitude).join(", ");
      longitudes = coordinates.map((coord) => coord.longitude).join(", ");
    }
  
      return {
        "Agri Promoter Date": item.agriPromoterDate,
        "Promoter Id": item.employeeCode,
        "Agri Promoter Name": item.employeeName,
        "Agri Promoter Code": item.agriPromoterCode,
        "State": item.state,
        "LGA": item.lga,
        "Village Name": item.villageName,
        "Crop Name": item.cropName,
        "Variety Name": item.varietyName,
        "Plant Height (cm)": item.plantHeightInCm || "N/A",
        "Stem girth (cm)": item.stemGirthInCm || "N/A",
        "Plant Growth Stage/Uniformity": item.plantGrowthStageUniformity || "N/A",
        "Demo Size (Square Meter)": item.demoSizeInSqm || "N/A",
        "Yield(kg)": item.yieldInKg || "0",         
        "Yield(Metrics tonnes/Ha)":item.yieldMetricsTonnesHa||0,
        "Farmer's Yield(Kg)":item.farmersYieldKg||0,
        "Farmer's Yield(Metrics tonnes/Ha)":item.farmersYieldMetricsTonnesHa||0,     
        "Latitude": latitudes,
        "Longitude": longitudes,
      };
    });
  
    convertToExcel(processedData, Object.keys(processedData[0]), filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);


//   const { sendRequest: getFarmerNumber } = useHttp();
//   useEffect(() => {
//     var urlfilter = "";
//     if (
//       stateName &&
//       typeof stateName === "string" &&
//       stateName.trim().length > 0
//     ) {
//       const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
//       urlfilter = urlfilter + `&stateName=${sanitizedState}`;
//     }

//     getFarmerNumber(
//       {
//         url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
//           "orgId"
//         )}&empId=${localStorage.getItem(
//           "empId"
//         )}&fieldExecutiveId=${employeeId}${urlfilter}`,
//       },
//       (data) => {
//         // console.log("farmerNumberList", data);

//         setFarmerData(data);
//       }
//     );
//   }, [employeeId, stateName]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Field Demonstration Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el)  => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                        var userid = 0;
                        if (e.target.value !== "0") userid = e.target.value;
                        setData([]);
                        setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillAgriPromoterData(
                        employeeId,
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Field Demonstration Date</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          <th>Doc No</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Village Name</th>
                          <th>Crop Name</th>
                          <th>Variety Name</th>
                          <th>Plant Height(cm)</th>
                          <th>Stem girth(cm)</th>
                          <th>Plant Growth Stage/Uniformity</th>
                          <th>Demo Size(Square Meter)</th>
                          <th>Yeild(kg)</th>

                           <th>Yield (Metrics tonnes/Ha)</th>
<th>Farmer's Yield (Kg)</th>
<th>Farmer's Yield (Metrics tonnes/Ha)</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            let coordinates = [];
                            try {
                              coordinates = typeof itm.plotCoordinates === "string" ? JSON.parse(itm.plotCoordinates) : itm.plotCoordinates;
                            } catch (error) {
                              console.error("Error parsing JSON:", error);
                              coordinates = [];
                            }                            const latitudes = coordinates.map(coord => coord.latitude).join(", ");
                            const longitudes = coordinates.map(coord => coord.longitude).join(", ");
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{i+1}</td>
                                <td>{itm.agriPromoterDate}</td>
                                <td>{itm.employeeCode}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.agriPromoterCode}</td>
                                <td>{itm.state}</td>
                                <td>{itm.lga}</td>
                                <td>{itm.villageName}</td>
                                <td>{itm.cropName}</td>
                                 <td>{itm.varietyName}</td>
                                <td>{itm.plantHeightInCm}</td>
                                <td>{itm.stemGirthInCm}</td>
                                <td>{itm.plantGrowthStageUniformity}</td>
                                <td>{itm.demoSizeInSqm}</td>
                                <td>{itm.yieldInKg}</td>
                                <td>{itm.yieldMetricsTonnesHa}</td>
                                <td>{itm.farmersYieldKg}</td>
                                <td>{itm.farmersYieldMetricsTonnesHa}</td>

                                
                                <td>{latitudes}</td>
                                <td>{longitudes}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgriPromoter;
